import { createFileRoute, redirect } from '@tanstack/react-router'
import { WelcomePage } from '../components/welcome-page'
import { AuthService } from '../services/auth-service'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    if (typeof window !== 'undefined') {
      // Verificar se está no modo de teste
      const testMode = localStorage.getItem("Sabhia-test-mode")
      if (testMode === "true") {
        throw redirect({ to: '/test' })
      }

      // Verificar se já está autenticado (nova sessão baseada em cliente)
      const sessao = AuthService.verificarSessao()
      if (sessao.isAuthenticated) {
        throw redirect({ to: '/dashboard' })
      }
    }
  },
  component: IndexComponent,
})

function IndexComponent() {
  // Página de boas-vindas que orienta o cliente sobre o acesso via magic link; autenticação real em /auth/$hub_login.
  return <WelcomePage />
}
